import CryptoJS from 'crypto-js/crypto-js'
export function encryptData (encryptData) {
  const data = CryptoJS.enc.Utf8.parse(JSON.stringify(encryptData)) // 转义一下数据
  const key = CryptoJS.enc.Utf8.parse('digital20230221o') // 秘钥 需要设置16位
  const iv = CryptoJS.enc.Utf8.parse('digital20230221o') // 偏移量
  const encrypted = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC
  })
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
};
export function decryptData (decryptStr, keyStr, ivStr) {
  const decryptBase64Str = CryptoJS.enc.Base64.parse(decryptStr)
  const key = keyStr?keyStr:CryptoJS.enc.Utf8.parse('digital20230221o') // 密钥 需要与加密秘钥保持一致
  const iv = ivStr?ivStr:CryptoJS.enc.Utf8.parse('digital20230221o') // 密钥偏移量
  const createCode = CryptoJS.lib.CipherParams.create({ ciphertext: decryptBase64Str }) // 将密文转换成 WordArray 对象
  const decryptedData = CryptoJS.AES.decrypt(createCode, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  const decryptedStr = CryptoJS.enc.Utf8.stringify(decryptedData).toString()
 
  return decryptedStr
};